<template>
  <div>
    <transition name="fade">
      <div v-if="reports.length > 0">
        <panel>
          <div slot="title">Processing reports</div>
          <div slot="body">
            <div class="row">
              <div class="col-xs-12">
                <div v-if="reports.length !== 0">
                  <div v-for="report of reports" class="row report-listing" :key="report.id">
                    <div class="col-xs-7 col-sm-7 col-md-8">
                      {{ report.company_name }} {{ report.registration_number }}
                    </div>
                    <div class="col-xs-5 col-sm-5 col-md-4">
                      <div class="progress">
                        <div class="progress-bar" role="progressbar"
                             :aria-valuenow="report.percent_complete" aria-valuemin="0"
                             aria-valuemax="100" :style="percentStyle(report.percent_complete)"
                             :id="report.report_id">
                          <span class="sr-only">{{ report.percent_complete }}% Complete</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center">
                  <div v-if="showProcessing">Processing...</div>
                  <div v-else>No reports processing</div>
                </div>
              </div>
            </div>
          </div>
        </panel>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import Panel from '@/components/app/Panel';

export default {
  computed: {
    ...mapGetters(['current_user']),
  },
  components: {
    Panel,
  },
  data() {
    return {
      reports: [],
    };
  },
  methods: {
    addReport(report) {
      this.reports.push(report);
      window.Echo.private('reports.' + report.id)
        .listen('.App\\Events\\ReportProcessingUpdate', (event) => {
          let i;
          for (i = 0; i < this.reports.length; i += 1) {
            if (this.reports[i].id === event.id) {
              Vue.set(this.reports[i], 'percent_complete', event.percent_complete);
              Vue.set(this.reports[i], 'status', event.status);
              if (event.status === 'processed' || event.status === 'failed') {
                this.reports.splice(i, 1);
                window.Echo.leave('reports.' + event.id);
              }
              if (event.status === 'processed') {
                this.$emit('report-processed');
              }

              /* We return here, when we found and dealt with the report */
              return;
            }
          }
        });
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    percentStyle(value) {
      return 'width:' + value + '%';
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
  .fade-leave-to
  /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
